<template>
  <div class="">
    <table class="table table-hover mb-0">
      <thead class="">
      <tr>
        <th v-for="(th,index) in titles" :key="index">{{ th }}</th>
      </tr>
      </thead>
      <tbody class="">
      <tr v-for="user in userDatas" :key="user.id">
        <td>{{ user.id }}</td>
        <td class="">
          <img :src="require('../assets/user_images/'+ user.image)" alt=""
               class="user-image shadow-sm">
        </td>
        <td>{{ user.name }}</td>
        <td>{{ user.email }}</td>
        <td class="">
          <span v-if="user.action === 'Accept'"
                class="badge bg-success"> {{ user.action }}</span>
          <span v-else-if="user.action === 'Pending'"
                class="badge bg-info"> {{ user.action }}</span>
          <span v-else class="badge bg-danger"> {{ user.action }}</span>
        </td>
        <td class="text-center">
          <div class="dropdown">
            <button type="button"
                    class="btn p-0 "
                    data-bs-toggle="dropdown">
              <i class="fa-solid fa-ellipsis-vertical"></i>
            </button>
            <div class="dropdown-menu">
              <a class="dropdown-item" href="javascript:void(0);">
                <i class="bx bx-edit-alt me-1"></i> Edit</a>
              <a class="dropdown-item" href="javascript:void(0);">
                <i class="bx bx-trash me-1"></i> Delete</a>
            </div>
          </div>
        </td>
        <td class="text-nowrap">{{ user.date }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "Table",
  data() {
    return {
      titles: ['No.', 'Image', 'User Name', 'Email','Status', 'Action', 'Date'],
      userDatas: [
        {
          id:1,
          image:'1.jpeg',
          name:"Operational",
          email: "Operational@gmail.com",
          action: "Accept",
          date: "10.2.2019"
        },
        {
          id:2,
          image:"11.jpeg",
          name:"astalkerheatlock",
          email: "astalkerheatlock@gmail.com",
          action: "Pending",
          date: "10.2.2019"
        },
        {
          id:3,
          image:"2.jpeg",
          name:"aredlegolascasino",
          email: "aredlegolascasino@gmail.com",
          action: "Accept",
          date: "10.2.2019"
        },
        {
          id:4,
          image:"22.jpeg",
          name:"bthedepartedse7en",
          email: "bthedepartedse7en@gmail.com",
          action: "Denied",
          date: "10.2.2019"
        },
        {
          id:5,
          image:"3.jpeg",
          name:"bdasbootpapillon",
          email: "bdasbootpapillon@gmail.com",
          action: "Accept",
          date: "10.2.2019"
        },{
          id:6,
          image:"33.jpeg",
          name:"bneosevensamurai",
          email: "bneosevensamurai@gmail.com",
          action: "Pending",
          date: "10.2.2019"
        },
        {
          id:7,
          image:"4.jpeg",
          name:"jpapillonrockyran",
          email: "jpapillonrockyran@gmail.com",
          action: "Accept",
          date: "10.2.2019"
        },
        {
          id:8,
          image:"44.jpeg",
          name:"jrushthedeparted",
          email: "jrushthedeparted@gmail.com",
          action: "Accept",
          date: "10.2.2019"
        },
        {
          id:9,
          image:"5.jpeg",
          name:"mthedepartedrocky",
          email: "mthedepartedrocky@gmail.com",
          action: "Accept",
          date: "10.2.2019"
        },
        {
          id:10,
          image:"55.jpeg",
          name:"mstandbymegollum",
          email: "mstandbymegollum@gmail.com",
          action: "Accept",
          date: "10.2.2019"
        },
        {
          id:11,
          image:"66.jpeg",
          name:"mdonniedarkoheat",
          email: "mdonniedarkoheat@gmail.com",
          action: "Accept",
          date: "10.2.2019"
        },
        {
          id:12,
          image:"77.jpeg",
          name:"cthejokerdoryrush",
          email: "cthejokerdoryrush@gmail.com",
          action: "Pending",
          date: "10.2.2019"
        }
      ],
    }
  },
}
</script>

<style scoped>
.user-image{
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.table{
  margin-bottom: 1rem;
  color: #697a8d;
  vertical-align: middle;
  border-color: #d9dee3;
}

</style>